<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'user.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateUser"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="currentUser.id === user.id ? 'Saját felhasználó törlése nem lehetséges' : 'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'user.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteUser()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
          :disabled="currentUser.id === user.id"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['user'],
  data() {
    return {
      deleteButtonLoader: false,
      deleteConfirmVisible: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/user'];
    }
  },
  methods: {
    async deleteUser() {
      this.deleteButtonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('user/delete', this.user.id);
        this.$store.dispatch('user/fetchAllWithPagination');
      } catch (e) {
      }
      this.deleteButtonLoader = false;
    },
    async updateUser() {
      this.$router.push('/users/update/' + this.user.id);
    }
  }
};
</script>
